import React from 'react';
var Badge = function (_a) {
    var label = _a.label, taille = _a.taille, system = _a.system, sansIcone = _a.sansIcone, couleur = _a.couleur;
    var classBadge = "fr-badge";
    if (taille === 'sm') {
        classBadge += ' fr-badge--sm';
    }
    if (system) {
        classBadge += ' fr-badge--' + system;
        if (sansIcone) {
            classBadge += ' fr-badge--no-icon';
        }
    }
    if (couleur) {
        classBadge += ' fr-badge--' + couleur;
    }
    return (React.createElement("p", { className: classBadge }, label));
};
Badge.defaultProps = {
    taille: 'md'
};
export default Badge;
